import styled from "@emotion/styled";
import UndoIcon from "@mui/icons-material/Undo";
import { Box, Button, Typography } from "@mui/material";
import theme from "../../../../theme";

export const SmartContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`;

export const SmartContentMessage = styled(Typography)``;

export const AdvancedSearchWrapper = styled(Box)`
  display: flex;
  align-items: center;
  margin-top: 12px;
  height: 25px;
`;

export const SmartContentItemWrapper = styled(Box)`
  display: flex;
  align-items: center;
  margin-top: 5px;
  background-color: ${theme.palette.grey[100]};
  padding: 8px;
  border-radius: 5px;
  width: 100%;
  justify-content: space-between;
`;

export const ClinicianName = styled(Typography)`
  text-transform: capitalize;
`;

export const AddMemberActionButtons = styled(Box)`
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  margin-left: 12px;

  & .MuiButton-root {
    white-space: nowrap;
  }
`;

export const SendReferralButton = styled(Button)``;

export const ReferralStatusText = styled(Typography)`
  font-weight: lighter;
  font-style: italic;
  font-size: small;
  color: ${theme.palette.grey[600]};
`;

export const SmartContentItemDetails = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const SendReferralDetailsWrapper = styled(Box)`
  padding: 10px;
  display: flex;
  gap: 5px;
  flex-direction: column;
`;

export const ReferralSendOptions = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 18px;
`;

export const ReferralMessageDetails = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 1px;
  align-items: center;
`;

export const ReferralRevokeBtn = styled(UndoIcon)`
  margin-right: 10px;
  cursor: pointer;
`;

export const CustomTooltipContent = styled.div`
  text-align: left;
`;

export const TooltipHeading = styled(Typography)`
  font-size: 13px;
  margin-top: 5px;
  color: ${theme.palette.grey[400]};
`;

export const TooltipBody = styled(Typography)`
  margin-top: 8px;
  font-size: 13px;
`;
